import React, { useState, useCallback } from 'react'

import TextArea from '../textArea'
import { EditIcon } from '../icons'
import TranslatesModal from '../translatesModal'

const TranslatedTextArea = ({
  onTranslationChange,
  translates = {},
  locales,
  defaultLocale,
  translatedField,
  withLibrary,
  optional,
  disabled,
  ...props
}) => {

  const [modalOpened, setModalOpened] = useState(false)

  const handleOpen = useCallback(() => {
    setModalOpened(true)
  }, [])

  const handleClose = useCallback(() => {
    setModalOpened(false)
  }, [])

  const handleConfirm = useCallback(values => {
    setModalOpened(false)
    onTranslationChange(translatedField, values)
  }, [onTranslationChange, translatedField])

  const handleClick = useCallback(e => {
    if (!e.target.value) {
      handleOpen()
    }
  }, [handleOpen])

  return (
    <React.Fragment>
      <TextArea {...props} onClick={handleClick} onAction={handleOpen} actionIcon={<EditIcon />} readOnly disabled={disabled}/>
      {
        modalOpened && (
          <TranslatesModal
            translates={translates}
            locales={locales}
            defaultLocale={defaultLocale}
            onClose={handleClose}
            onChange={handleConfirm}
            textArea
            withLibrary={withLibrary}
            fullWidth
            optional={optional}
            disabled={disabled}
          />
        )
      }
    </React.Fragment>
  )
}

export default TranslatedTextArea
